<template>
  <v-dialog
    v-model="opened"
    max-width="450"
    content-class="settings-dialog"
    persistent
  >
    <h3 class="settings-dialog__title">
      {{ $t('workersList.displayedColumns') }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <div class="settings-dialog__params-wrapper">
      <ul class="settings-dilog__params">
        <li v-for="(item, key) in headerParams.slice(0, 6)" :key="key">
          <v-checkbox
            v-model="activeColumns"
            color="warning"
            :label="$t(item.title)"
            :value="item.key"
            hide-details
          />
        </li>
      </ul>

      <ul class="settings-dilog__params">
        <template v-for="(item, key) in headerParams.slice(6)">
          <li v-if="$can(item.permission)" :key="key">
            <v-checkbox
              v-model="activeColumns"
              color="warning"
              :label="$t(item.title)"
              :value="item.key"
              hide-details
            />
          </li>
        </template>
      </ul>
    </div>

    <v-btn class="mt-5 elevation-0" color="warning" block @click="onSave">
      {{ $t('common.btns.save') }}
    </v-btn>
  </v-dialog>
</template>

<script>
export default {
  model: {
    event: 'change',
    prop: 'value',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hiddenColumns: {
      type: [Array, null],
      default: null,
    },
  },
  data: () => ({
    activeColumns: [],
  }),
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    headerParams() {
      return [
        { title: 'workersList.investorFullName', key: 'investor-name' },
        { title: 'auto.fields.brand', key: 'auto-brand' },
        { title: 'auto.fields.model', key: 'auto-model' },
        { title: 'workersList.rentPrice', key: 'rent-price' },
        { title: 'driverAdd.kaspi', key: 'kaspi-number' },
        { title: 'workersList.shift', key: 'shift' },
        { title: 'common.fields.phoneRelative', key: 'phone-relative' },
        {
          title: 'common.table.coming',
          key: 'coming',
          permission: 'workdesk_income',
        },
        {
          title: 'workersList.explanation',
          key: 'explanation',
          permission: 'workdesk_view_explanation',
        },
        {
          title: 'common.table.duty',
          key: 'duty',
          permission: 'workdesk_debt',
        },
        {
          title: 'common.table.consumption',
          key: 'consumption',
          permission: 'workdesk_expense',
        },
      ];
    },
  },
  methods: {
    onSave() {
      const hiddenColumns = this.headerParams.reduce((acc, item) => {
        if (!this.activeColumns.includes(item.key)) {
          acc.push(item.key);
        }

        return acc;
      }, []);

      localStorage.setItem(
        'workers-board-hidden-columns',
        JSON.stringify(hiddenColumns),
      );

      this.$emit('save', hiddenColumns);
      this.opened = false;
    },
  },
  created() {
    let columns = this.headerParams.map(({ key }) => key);

    if (this.hiddenColumns) {
      columns = columns.filter((key) => !this.hiddenColumns.includes(key));
    }

    this.activeColumns = columns;
  },
};
</script>

<style lang="scss">
.settings-dialog {
  padding: 10px 15px;
  background-color: #fff;

  &__params-wrapper {
    display: flex;
    justify-content: space-between;

    ul {
      padding: 0;

      &:not(:last-child) {
        margin-right: 15px;
      }

      li {
        list-style: none;
      }
    }
  }

  h3 {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    line-height: 1.3;
    color: #424242;
  }
}
</style>
